// src/pages/ToolRenderer.jsx
import React from 'react';
import { useParams } from 'react-router-dom';

// Import the components you want to switch between
import ChatPage from './Chat/ChatPage';
import NotFound from './NotFound'; // Good practice to have a fallback
import PromptOptimizer from './TextTools/PromptOptimizer';
import SummarizeDocument from './TextTools/SummarizeDocument';
import AskDoc from './TextTools/AskDoc';
import Paraphraser from './TextTools/Paraphraser';
import TranslateTool from './TextTools/TranslateTool';
import GenerateContentTool from './TextTools/GenerateContentTool';
import ArticleGenerator from './TextTools/ArticleGenerator';
import LearningAssistant from './LearningAssistant/LearningAssistant';
import QuizGenerator from './TextTools/QuizGenerator';
import MotivationLetter from './TextTools/MotivationLetter';
import MindMap from './TextTools/MindMap';
import WordcloudGenerator from './TextTools/WordcloudGenerator';
import QRCodeGenerator from './TextTools/QRCodeGenerator';
// import ArxivSearch from './TextTools/ArxivSearch';
import PptxToGif from './TextTools/PptxToGif';
import ImageGenerator from './ImageTools/ImageGenerator';
import ImageEditor from './ImageTools/ImageEditor';
import AskImage from './ImageTools/AskImage';
import AddTextToImage from './ImageTools/AddTextToImage';
import RemoveBackground from './ImageTools/RemoveBackground';
import SharpenImage from './ImageTools/SharpenImage';
import EnhanceColors from './ImageTools/EnhanceColors';
import DenoiseImage from './ImageTools/DenoiseImage';
import ResizeImage from './ImageTools/ResizeImage';
import CropImage from './ImageTools/CropImage';
import RoundImage from './ImageTools/RoundImage';
import ConvertImage from './ImageTools/ConvertImage';
import DisplayMetadata from './ImageTools/DisplayMetadata';
// Video tools
import VideoSummarizer from './VideoTools/VideoSummarizer';
import VideoTranscriber from './VideoTools/VideoTranscriber';
import VideoSubtitler from './VideoTools/VideoSubtitler';
import AddTextToVideo from './VideoTools/AddTextToVideo';
import PptToVideo from './VideoTools/PptToVideo';
import ApplyFilter from './VideoTools/ApplyFilter';
import AddAudioToVideo from './VideoTools/AddAudioToVideo';
import VideoToAudio from './VideoTools/VideoToAudio';
import VideoToImage from './VideoTools/VideoToImage';
import VideoConverter from './VideoTools/VideoConverter';
import RemoveAudio from './VideoTools/RemoveAudio';

// Audio tools
import AudioSummarizer from './AudioTools/AudioSummarizer';
import GenerateAudio from './AudioTools/GenerateAudio';
import AudioTranscriber from './AudioTools/AudioTranscriber';
import AudioBackgroundTool from './AudioTools/AudioBackgroundTool';
import AudioTrimmer from './AudioTools/AudioTrimmer';
import AudioMerger from './AudioTools/AudioMerger';
import VoiceRecorder from './AudioTools/VoiceRecorder';
import AudioConverter from './AudioTools/AudioConverter';








// This is your generic tool page component from before
const GenericToolPage = () => {
    const { toolSlug } = useParams();
    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-white text-3xl">Tool: {toolSlug}</h1>
            <p className="text-gray-400 mt-2">Generic tool interface coming soon...</p>
        </div>
    );
};


const ToolRenderer = () => {
    const { toolSlug, projectId } = useParams();

    // The "gatekeeper" logic
    switch (toolSlug) {
        case 'Chat':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ChatPage />;
        case 'Optimize-Prompt':
            // If the slug is 'chat', render the full-featured ChatPage
            return <PromptOptimizer />;
        case 'Summarize-Doc':
            // If the slug is 'chat', render the full-featured ChatPage
            return <SummarizeDocument />;
        case 'Ask-Doc':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AskDoc />;
        case 'Paraphraser':
            // If the slug is 'chat', render the full-featured ChatPage
            return <Paraphraser />;
        case 'Translate':
            // If the slug is 'chat', render the full-featured ChatPage
            return <TranslateTool />;
        case 'Generate-Content':
            // If the slug is 'chat', render the full-featured ChatPage
            return <GenerateContentTool />;
        case 'Generate-Draft-Article':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ArticleGenerator />;
        case 'Learning-Assistant':
            // If the slug is 'chat', render the full-featured ChatPage
            return <LearningAssistant />;
        case 'Quiz':
            // If the slug is 'chat', render the full-featured ChatPage
            return <QuizGenerator />;
        case 'Motivation-Letter':
            // If the slug is 'chat', render the full-featured ChatPage
            return <MotivationLetter />;
        case 'Mind-Map':
            // If the slug is 'chat', render the full-featured ChatPage
            return <MindMap />;
        case 'Wordcloud':
            // If the slug is 'chat', render the full-featured ChatPage
            return <WordcloudGenerator />;
        case 'QR-Code':
            // If the slug is 'chat', render the full-featured ChatPage
            return <QRCodeGenerator />;
        //case 'Ask-arXiv':
            // If the slug is 'chat', render the full-featured ChatPage
            //return <ArxivSearch />;
        case 'PowerPoint-to-GIF':
            // If the slug is 'chat', render the full-featured ChatPage
            return <PptxToGif />;
        case 'Generate-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ImageGenerator />;
        case 'Edit-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ImageEditor />;
        case 'Ask-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AskImage />;
        case 'Add-Text-to-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AddTextToImage />;
        case 'Remove-Background':
            // If the slug is 'chat', render the full-featured ChatPage
            return <RemoveBackground />;
        case 'Sharpen-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <SharpenImage />;
        case 'Enhance-Colors':
            // If the slug is 'chat', render the full-featured ChatPage
            return <EnhanceColors />;
        case 'Denoise-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <DenoiseImage />;
        case 'Resize-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ResizeImage />;
        case 'Crop-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <CropImage />;
        case 'Round-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <RoundImage />;
        case 'Convert-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ConvertImage />;
        case 'Display-Metadata':
            // If the slug is 'chat', render the full-featured ChatPage
            return <DisplayMetadata />;
        case 'Video-Summarizer':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoSummarizer />;
        case 'Video-to-Text':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoTranscriber />;
        case 'Subtitle-Video':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoSubtitler />;
        case 'Add-Text-to-Video':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AddTextToVideo />;
        case 'Powerpoint-to-Video':
            // If the slug is 'chat', render the full-featured ChatPage
            return <PptToVideo />;
        case 'Apply-Filter':
            // If the slug is 'chat', render the full-featured ChatPage
            return <ApplyFilter />;
        case 'Add-Audio-to-video':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AddAudioToVideo />;
	// case 'Remove-Audio':
            // If the slug is 'chat', render the full-featured ChatPage
            // return <RemoveAudio />;
        case 'Video-to-Audio':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoToAudio />;
        case 'Video-to-Image':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoToImage />;
        case 'Convert-Video':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VideoConverter />;
        case 'Audio-Summarizer':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioSummarizer />;
        case 'Generate-Audio':
            // If the slug is 'chat', render the full-featured ChatPage
            return <GenerateAudio />;
        case 'Audio-to-Text':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioTranscriber />;
        case 'Audio-Background':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioBackgroundTool />;
        case 'Trim-Audio':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioTrimmer />;
        case 'Merge-Audios':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioMerger />;
        case 'Record-Voice':
            // If the slug is 'chat', render the full-featured ChatPage
            return <VoiceRecorder />;
        case 'Convert-Audio':
            // If the slug is 'chat', render the full-featured ChatPage
            return <AudioConverter />;

        
        
        
        // You can add more special cases here if needed in the future
        // case 'summarize-doc':
        //     return <SummarizeDocPage />;

        default:
            // For all other slugs, render the generic tool page
            return <GenericToolPage />;
    }

    // Optional: You could add a check here to see if the toolSlug is valid
    // by fetching from an API, and if not, render <NotFound />.
    // For now, the default case handles it.
};

export default ToolRenderer;

